'use strict';

import React, { PropTypes } from 'react';
import PureRenderMixin from '../mixins/PureRenderMixin';
import Icon from '../atoms/Icon';
import createFlexibleImageQueueMixin from '../mixins/createFlexibleImageQueueMixin';
import ViewportTestMixin from '../mixins/ViewportTestMixin';
import Colors from '../constants/Colors';
import gradient from '../utils/gradient';

var StampThumbnail = React.createClass({
  mixins: [createFlexibleImageQueueMixin(60), PureRenderMixin, ViewportTestMixin],

  propTypes: {
    thumbnail: PropTypes.object,
    allowEmpty: PropTypes.bool
  },

  getImageOptions() {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return {
      image: this.props.thumbnail,
      allowEmpty: this.props.allowEmpty,
      mode: 'scale_crop',
      sizes: {
        normal: true,
        retina: devicePixelRatio > 1.5 && this.state.isInViewport
      }
    };
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.thumbnail !== this.props.thumbnail ||
        prevState.isInViewport !== this.state.isInViewport) {

      this.updateImageQueue();
    }
  },

  render() {
    var { thumbnail } = this.props,
        style = {};

    if (!thumbnail) {
      style.backgroundColor = Colors.GRAY_MID;
    } else if (!this.hasLoadedImage()) {
      style.backgroundImage = gradient('#' + thumbnail.colors.top, '#' + thumbnail.colors.bottom);
    } else {
      style.backgroundImage = this.getBackgroundImageUrl();
    }

    return (
      <div className='StampItem-preview'>
        {this.renderLoaderImg()}
        <div className='StampItem-coverImage'
             style={style}>
          {this.props.children}
        </div>
      </div>
    );
  }
});

export default StampThumbnail;



/** WEBPACK FOOTER **
 ** ./molecules/StampThumbnail.jsx
 **/